import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { catchError, map, tap, filter } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class VersionService {

  private baseUrl: string = environment.services_url;
  private versionSubject = new BehaviorSubject<string | null>(null);
  // Filtrar valores null para que solo emita cuando tenga un valor real
  public version$: Observable<string> = this.versionSubject.asObservable().pipe(
    filter(version => version !== null)
  );
  private isLoading = false;

  constructor(private http: HttpClient) {
    // Cargar versión automáticamente al inicializar el servicio
    // IMPORTANTE: Suscribirse para que realmente ejecute la llamada HTTP
    this.loadVersion().subscribe();
  }

  /**
   * Obtiene la versión actual de forma síncrona
   * Retorna 'X.X.X' solo si hubo error
   */
  getVersion(): string {
    return this.versionSubject.value || 'X.X.X';
  }

  /**
   * Obtiene la versión como Observable
   * Útil para usar con async pipe en templates
   */
  getVersion$(): Observable<string> {
    // Si ya tenemos la versión, retornarla inmediatamente
    if (this.versionSubject.value) {
      return of(this.versionSubject.value);
    }

    // Si no, retornar el observable que se actualizará cuando llegue la respuesta
    return this.version$;
  }

  /**
   * Carga la versión desde el servidor
   * Retorna un Observable que se puede suscribir si se necesita
   */
  loadVersion(): Observable<string> {
    // Evitar múltiples llamadas simultáneas
    if (this.isLoading) {
      return this.version$;
    }

    this.isLoading = true;

    return this.http.get<{ version: string }>(`${this.baseUrl}/health/version`)
      .pipe(
        map(response => response.version),
        tap(version => {
          console.log('Versión obtenida del servidor:', version);
          this.versionSubject.next(version);
          this.isLoading = false;
        }),
        catchError(error => {
          console.error('Error al obtener versión del servidor:', error);
          this.versionSubject.next('X.X.X');
          this.isLoading = false;
          return of('X.X.X');
        })
      );
  }

  /**
   * Fuerza la recarga de la versión desde el servidor
   */
  reloadVersion(): Observable<string> {
    this.isLoading = false;
    return this.loadVersion();
  }
}